const translations = {
  "en": {
    "Technical Signals For You": "Technical Signals For You"
  },
  "zh-tw": {
    "Technical Signals For You": "為你精選的技術訊號"
  }
};

export default translations;
